import { List } from '../List'
import { CommonWork } from '../CommonWork'

export class ForeignCitationParent extends List {
  constructor(obj) {
    super(ForeignCitation, obj)
  }
}

export class ForeignCitation {
  constructor(obj) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.partNumber = obj?.partNumber || null
    this.magazineNumber = obj?.magazineNumber || null
    this.page = obj?.page || null
    this.publicationOutput = obj?.publicationOutput || null
    this.fullBibliographicDescription = obj?.fullBibliographicDescription || null
    this.doi = obj?.doi || null
    this.internationalMagazine = obj?.internationalMagazine || null
    this.tome = obj?.tome || null
    this.articleTitleEng = obj?.articleTitleEng || null
    this.isForeign = obj?.isForeign || false
    this.isVac = obj?.isVac || false
    this.pageFrom = obj?.page.split('–')[0] || null
    this.pageTo = obj?.page.split('–')[1] || null
  }

  getForAPI() {
    return {
      id: this.id,
      commonWork: this.commonWork.getForAPI(),
      partNumber: this.partNumber,
      magazineNumber: this.magazineNumber,
      page: this.pageFrom + '-' + this.pageTo,
      publicationOutput: this.publicationOutput,
      fullBibliographicDescription: this.fullBibliographicDescription,
      doi: this.doi,
      internationalMagazine: this.internationalMagazine,
      tome: this.tome,
      articleTitleEng: this.articleTitleEng,
      isForeign: this.isForeign,
      isVac: this.isVac
    }
  }
}
